import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"

const addContractSetting = (contract_number_method,contract_number_prefix,contract_number_number,contract_number_suffix) => {
  return axios.post(API + "company/company-settings/", {
    contract_number_method,
    contract_number_prefix,
    contract_number_number,
    contract_number_suffix,

  
  },{headers: authHeader(),});
};
const AddContractSettingService = {
    addContractSetting,
    
  };
  export default AddContractSettingService;